const pointsPerPixel = 72 / 96;

const pixelToPoint = (pixels) => pixels * pointsPerPixel;

const fontSizeUnderCursor = (editor) => {
  const node = editor.view.domAtPos(editor.state.selection.from).node;
  const element = node?.nodeType === Node.TEXT_NODE ? node.parentElement : node;

  if (element instanceof HTMLElement) {
    const pxFontSize = parseFloat(window.getComputedStyle(element).fontSize);
    return pixelToPoint(pxFontSize);
  }
  return 12; // TODO: Keep the editor default (this knowledge don't belong here)
};

export { pixelToPoint, fontSizeUnderCursor };
